// extracted by mini-css-extract-plugin
export var aiStarIcon = "_bc-4";
export var closeButton = "_bc-6";
export var dismissButton = "_bc-3";
export var editImageWithAiContainer = "_bc-8";
export var imageUploadWrapper = "_bc-7";
export var misspelledWord = "_bc-5";
export var spellCheckContainer = "_bc-2";
export var spin = "_bc-1";
export var spinning = "_bc-0";